import { render, staticRenderFns } from "./debut-stream-details.vue?vue&type=template&id=319f96cf&scoped=true&lang=pug&"
import script from "./debut-stream-details.vue?vue&type=script&lang=js&"
export * from "./debut-stream-details.vue?vue&type=script&lang=js&"
import style0 from "./debut-stream-details.vue?vue&type=style&index=0&id=319f96cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319f96cf",
  null
  
)

export default component.exports